import React, { Component } from 'react';
import PropTypes from 'prop-types';

const LOCALES = {
    "multi": {
        label: {
            fr: "Ctrl + clic pour une sélection multiple",
            en: "Ctrl + click for multiple selection"
        }
    }
};

class Dropdown extends Component {
    constructor(props) {
        super(props);
        const defaultValue = this.props.isMulti ? [] : "";
        this._handleChange = this._handleChange.bind(this);
        this.state = {
          value: this.props.value || defaultValue,
        };
    }

    render()
    {
        return this._getWrapper();
    }

    componentDidUpdate(){
        if (this.input)
        {
            this.input.disabled = null;
            if (this.props.hasFocus)
            {
                this.input.focus();
            }
        }
    }

    _getWrapper() {
        //Plus qu'une seule valeur dans le dataSource, liste select
        if (this.props.dataSource && this.props.dataSource.length > 1)
        {
            var noteMulti = "";

            if (this.props.isMulti)
            {
                noteMulti = <p className="texte_petit">{LOCALES["multi"].label[this.props.lang]}</p>
            }

            return (
                <div className={`${this.props.wrapperClass||""}`}>
                    {this._getLabel()}
                    {this._getSelect()}
                    {noteMulti}
                </div>
            );
        }
        else if (this.props.dataSource && this.props.dataSource.length === 1 && this.props.value) //Si le datasource est 1 ou 0 mais que l'on a une valeur "truthy"/existante (different de null,undefined,0,false,'')
        {
            return (
                <div id={'wrapper_' + this.props.id} className={`${this.props.wrapperClass}`}>
                    {this._getLabel()}
                    <span id={this.props.id} title={this.props.tooltip||""} style={{"width":"100%"}} className={`form-control ${this.props.inputClass||""}`} ref={(input) => this.input = input}>{this.props.dataSource[0][this.props.textField||'label']}</span>
                </div>
            );
        }
        else //Valeur "falsy"
        {
            return (
                <div id={'wrapper_' + this.props.id} className={`hidden ${this.props.wrapperClass || ''}`}>
                    <span>Filtre non visible</span>
                </div>
            );
        }
    }
    _getSelect() {
        return (
            <select id={this.props.id} name={this.props.name||""} title={this.props.tooltip||""} size={this.props.size} multiple={this.props.isMulti?"multiple":""} className={`form-control ${this.props.inputClass||""}`} value={this.props.value} ref={(input) => this.input = input} onChange={this._handleChange}>
                {this._getSelectOptions()}
            </select>
        );
    }

    _getLabel(){
        if (this.props.label)
        {
            return (
                <label className={`form-label ${this.props.labelClass||""}`} htmlFor={this.props.id}>{this.props.label}</label>
            )
        }
    }
    
    _getSelectOptions() {

        if (this.props.dataSource && this.props.dataSource.length > 0)
        {
            return this.props.dataSource.map((item,i) => {
                let value = item[this.props.valueField||'value'];
                let text = item[this.props.textField||'label'];
                return <option key={i} value={value} >{ text }</option>
            })
        }
    }
    
    _handleChange(e) {
        var value = [];
        var label = [];
        let options = this.input.options;

        for (var i = 0; i < options.length; i++) {
            if (options[i].selected) {
                value.push(options[i].value);
                label.push(options[i].textContent);
            }
        }
       
        if (this.props.onChange)
        {
            if (this.props.isMulti)
            {
                this.props.onChange(this.input,value,label);
            }
            else
            {
                this.props.onChange(this.input,value.join(''),label.join(''));
            }
        }
    }
}

Dropdown.propTypes = {
    "id": PropTypes.string.isRequired,
    "lang": PropTypes.string.isRequired,
    "name": PropTypes.string,
    "label": PropTypes.string,
    "hasFocus": PropTypes.bool,
    "isMulti": PropTypes.bool,
    "value": PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.array]),
    "dataSource": PropTypes.array,
    "valueField": PropTypes.string,
    "textField": PropTypes.string,
    "tooltip": PropTypes.string,
    "inputClass": PropTypes.string,
    "inputWrapperClass": PropTypes.string,
    "labelClass": PropTypes.string,
    "wrapperClass": PropTypes.string,
    "onChange": PropTypes.func
};

export default Dropdown;